import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Platform } from 'ionic-angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';

@Component({
  selector: 'ec-search',
  templateUrl: './recherche.html'
})
export class RechercheComponent implements OnInit {
    private recherche: any = '';
    @Output() search: EventEmitter<any> = new EventEmitter();

    constructor(
        private platform: Platform,
        private ga: GoogleAnalytics
    ) {}

    ngOnInit() {}
    
    onSubmit(): any {
        this.platform.ready().then(_ => {
            this.ga.trackEvent("Recherche", "submit", this.recherche);
        });
        this.search.emit(this.recherche);
    }
}


// WEBPACK FOOTER //
// ./src/pages/recherche/recherche.ts